import { render } from "./BaseSelectDropdown.vue?vue&type=template&id=4a535f22&ts=true"
import script from "./BaseSelectDropdown.vue?vue&type=script&lang=ts"
export * from "./BaseSelectDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__